import ValidationType from '../ValidationType';

class ContainsValueCaseInsensitive extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    const errors = [];
    const compareValue = validation.value || '';
    const currentValue = fieldResponse.currentValue || '';

    // Attempt to find the compare value within the current value (case-insensitive)
    const compareValueUpper = compareValue.toUpperCase();
    const currentValueUpper = currentValue.toUpperCase();
    if (currentValueUpper && !currentValueUpper.includes(compareValueUpper)) {
      const error = this.createValidationError({
        fieldResponse,
        key: 'ERROR_CONTAINS_VALUE_CASE_INSENSITIVE',
        values: { value: compareValue },
        message: `Value should contain '${compareValue}'`,
      });
      errors.push(error);
    }
    return errors;
  }
}

export default ContainsValueCaseInsensitive;
